import { css } from 'styled-components';
import { AvatarProps } from '@/shared/components/avatar/index';

const styles = () => css<Pick<AvatarProps, 'clickable' | 'onClick'>>`
  display: flex;
  justify-content: center;
  align-items: center;
  user-select: none;
  width: 40px;
  height: 40px;
  overflow: hidden;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.neutral.palette500};
  text-align: center;
  font-size: ${({ theme }) => theme.typography.sizes.xl}px;
  font-weight: ${({ theme }) => theme.typography.weight.bold};
  cursor: ${({ onClick, clickable }) => (onClick || clickable ? 'pointer' : 'default')};

  img {
    display: block;
  }

  &:focus {
    outline: 1px ${({ theme }) => theme.colors.primary.palette700} solid;
  }
`;

export default styles;
